/**
 * 便利メソッドクラスです。
 */
 export default class MathUtil {
    random(min, max) {
      return Math.random() * (max - min) + min
    }
  }